import { Link } from '@/components/link/Link'
import { Popover, PopoverContent, PopoverTrigger } from '@/components/popover/Popover'
import { kPaxtonCitatorHelpCenterUrl } from '@/constants/constants-links'
import { CaseReviewTag } from '@/citator/components/CaseReviewTag'
import type { DisplayableCaseReview } from '@/citator/schema/case-review-schema'
import { kCaseReviewDefinitions } from '@/citator/utils/case-review-definitions'

const CITATOR_HELP_CENTER_URL = kPaxtonCitatorHelpCenterUrl

export type CaseReviewInfoTagProps = {
  /** Citator review enum. Callers should gate with `isDisplayableCaseReview` upstream. */
  review: DisplayableCaseReview
  /** Analytics-only: fires when the user opens the outcome popover. */
  onTagClick?: () => void
}

/** Citing-case review badge with a click-through info popover. */
export function CaseReviewInfoTag({ review, onTagClick }: CaseReviewInfoTagProps) {
  const info = kCaseReviewDefinitions[review]

  return (
    <Popover>
      <PopoverTrigger asChild>
        <button
          type="button"
          onClick={onTagClick}
          className="group inline-flex self-start cursor-pointer focus:outline-hidden focus-visible:ring-2 focus-visible:ring-brand-500 rounded-full"
        >
          <CaseReviewTag review={review} className="group-data-[state=open]:bg-brand-neutral-100 group-data-[state=open]:ring-brand-neutral-600" />
        </button>
      </PopoverTrigger>
      <PopoverContent width="xl" showCloseButton reserveCloseButtonSpace={false} showArrow side="bottom" align="center" className="max-w-[calc(100vw-2rem)]">
        <div className="flex flex-col gap-2 text-brand-neutral-950">
          <p className="text-sm font-semibold leading-5">{info.label}</p>
          <p className="text-xs font-normal leading-4">{info.body}</p>
          <Link href={CITATOR_HELP_CENTER_URL} external size="sm">
            Learn more
          </Link>
        </div>
      </PopoverContent>
    </Popover>
  )
}
